<template>
  <div class="internal-contact-card" @click="$emit('select', contact)">
    <div class="internal-contact-card__avatar">
      <span class="material-icons-sharp">person</span>
    </div>
    <div class="internal-contact-card__info">
      <div class="internal-contact-card__name">{{ contact.alias }}</div>
      <div class="internal-contact-card__email">{{ contact.contact_email }}</div>
    </div>
    <div class="internal-contact-card__arrow">
      <span class="material-icons-sharp">chevron_right</span>
    </div>
  </div>
</template>

<style scoped>
.internal-contact-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.internal-contact-card:hover {
  background-color: rgba(97, 29, 233, 0.05);
}

.internal-contact-card__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(97, 29, 233, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #611DE9;
  margin-right: 12px;
}

.internal-contact-card__info {
  flex: 1;
}

.internal-contact-card__name {
  font-weight: 600;
  font-size: 14px;
}

.internal-contact-card__email {
  font-size: 12px;
  color: #6c757d;
}

.internal-contact-card__arrow {
  color: #6c757d;
}
</style>

<script>
export default {
  name: "InternalContactCard",
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
};
</script>
